import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-dash-card-popup-tooltip',
    templateUrl: './dash-card-popup-tooltip.component.html',
    styleUrls: [
        './dash-card-popup-tooltip.component.scss'
    ],
    standalone: false
})
export class DashCardPopupTooltipComponent
{
    @Input() header: boolean = true;
    @Input() footer: boolean = true;
}
